import { Component, OnInit } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { environment } from '@tv3/environments/environment'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { AuthService } from '@tv3/services/auth.service'

@Component({
  selector: 'app-acm-inbox-promo-dialog',
  templateUrl: './acm-inbox-promo-dialog.component.html',
  styleUrls: ['./acm-inbox-promo-dialog.component.scss'],
  host: {
    class: 'modal-content',
  },
})
export class AcmInboxPromoDialogComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<AcmInboxPromoDialogComponent>,
    private authService: AuthService,
    private amp: AmplitudeService
  ) {}

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }

  goToACM(path: string) {
    this.amp.logEvent('acm-inbox-promo-item-clicked')
    window.open(`${environment.acmAppUrl}/login?token=${this.authService.token}&redirectURL=${path}`, '_blank')
  }
}
